/**
 * client/src/components/ManifestePoste — annonce le manifeste PWA de la page courante.
 * @author Dr Hamid MADANI <drmdh@msn.com>
 *
 * Sans rendu. Suit la navigation et pointe `<link rel="manifest">` vers le manifeste du poste
 * (voir `utils/manifeste-poste`) : le guichet installé depuis `/counter` rouvre `/counter`.
 *
 * On MODIFIE le lien existant plutôt que d'en ajouter un : deux liens `manifest` dans la page,
 * et le navigateur ne retient que le premier.
 */
import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { manifestePourChemin } from '../utils/manifeste-poste';

export default function ManifestePoste() {
  const { pathname } = useLocation();

  useEffect(() => {
    const lien = document.querySelector('link[rel="manifest"]');
    if (!lien) return;
    const voulu = manifestePourChemin(pathname);
    // `getAttribute` et non `href` : `href` rend l'URL absolue, la comparaison échouerait toujours
    // et chaque navigation réécrirait le lien — ce qui relance la lecture du manifeste.
    if (lien.getAttribute('href') !== voulu) lien.setAttribute('href', voulu);
  }, [pathname]);

  return null;
}
